import { render, staticRenderFns } from "./YouTubeIcon.vue?vue&type=template&id=5d44ac90&scoped=true&"
import script from "./YouTubeIcon.vue?vue&type=script&lang=js&"
export * from "./YouTubeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d44ac90",
  null
  
)

export default component.exports